import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import vuetify from './plugins/vuetify';

// Firebase
import * as firebase from 'firebase/app';
import 'firebase/auth';
import firebaseConfig from './firebaseConfig';
firebase.initializeApp(firebaseConfig)

// SocekIO
// import socketio from 'socket.io-client';
// const socketInstance = socketio.connect(process.env.VUE_APP_SERVER_BASE_URL, {
//   query: {
//     token: '123456'
//   }
// });
// import VueSocketIO from 'vue-socket.io';
// Vue.use(new VueSocketIO({
//   debug: process.env.NODE_ENV === 'development',
//   connection: socketInstance,// process.env.VUE_APP_SERVER_BASE_URL,
//   // transportOptions: {
//   //   polling: {
//   //     extraHeaders: {
//   //       'x-auth': '12345'
//   //     }
//   //   }
//   // },
//   vuex: {
//     store,
//     actionPrefix: 'SOCKET_',
//     mutationPrefix: 'SOCKET_'
//   }
// }));

// ShortKey
Vue.use(require('vue-shortkey'));

// Vue Clipboard
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

// Vuetify Confirm
// import VuetifyConfirm from 'vuetify-confirm'
// Vue.use(VuetifyConfirm, {
//   buttonTrueText: 'כן',
//   buttonFalseText: 'לא',
//   width: 300,
//   color: 'warning',
//   icon: 'warning',
//   property: '$confirm'
// })

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')